// 手写防抖
export default function debounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(this, args);
        }, wait);
    }
};

// 缓存是手机端还是PC端
export const isMobile = () => {
    // 移动端断点
    const MOBILE_BREAK_POINT = 768;
    const width = window.innerWidth;

    return /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || (width <= MOBILE_BREAK_POINT);
}

// 初始化gamyeap关键信息
export const initIsMobile = () => {
    return isMobile();
}

// 格式化封面信息
export const formatCover = (originalUrl) => {
    // 如果不是阿里云 OSS 的链接，直接返回
    if (!originalUrl || !originalUrl.includes('aliyuncs.com')) {
        return originalUrl;
    }

    try {
        // 1. 从原始 URL 中提取文件名和参数
        const matches = originalUrl.match(/thumbnails%2F([^?]+)(\?[^?]+)?/);
        if (!matches) {
            console.warn('Failed to extract filename from URL:', originalUrl);
            return originalUrl;
        }

        // 2. 获取文件名和参数
        const [, filename, queryParams = ''] = matches;
        
        // 3. 解码并重新编码文件名
        const decodedFilename = decodeURIComponent(filename);
        const encodedFilename = encodeURIComponent(decodedFilename);
        
        // 4. 构建新的路径（保留原始查询参数）
        return `/images/game/thumbnails/${encodedFilename}${queryParams}`;
        
    } catch (error) {
        console.error('Error in formatCover:', error);
        return originalUrl;
    }
};
